<template>
  <v-card color="#124076" class="rounded-lg pb-3" style="position: absolute" dark >
    <v-card-title class="py-1">
      <v-icon
        medium
        left
        color="blue"
      >
        mdi-map-marker-radius
      </v-icon>
      <span class="text-subtitle-1 font-weight-light">Kenya</span>
      <v-spacer></v-spacer>
      <v-icon class="pr-1" size="small" color="red">mdi-radio-tower</v-icon>
      <span class="text-subtitle-2 font-weight-light">
        Started 2 mins ago
      </span>
    </v-card-title>
    <v-btn
      x-small
      text
      class="text-justify"
      @click="$emit('openObservationPostWindow')"
    >
      Kenya’s Ruto dismisses almost entire cabinet after nationwide <br/>protests,
      but still wants to remain in power.
    </v-btn>
    <v-card-actions>
      <v-row
        class="justify-space-between mt-0"
        v-for="n in 9" 
        :key="n"
      >
          <v-bottom-sheet width="1200px">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                  elevation="0"
                  v-bind="attrs"
                  v-model="sheet"
                  v-on="on"
                  color="transparent" 
                  density="compact"
                  padding="0px"
                  class="pb-0"
                  box-shadow="0px"
              >
              <!--This area will be replaced with the actual profile images in time.-->
                <v-avatar size="35">
                  <v-img
                    alt=""
                    :src="`https://randomuser.me/api/portraits/thumb/men/${n}.jpg`"
                  ></v-img>
                </v-avatar>
              </v-btn>
            </template>
              <profilePage/>
          </v-bottom-sheet>
      </v-row>
      <v-row>
        <v-icon size="14">mdi-plus-circle</v-icon>
        <span class="caption">23.3k...</span>
      </v-row>
    </v-card-actions>
  </v-card>
</template>
<script>
import profilePage from './profilePage'
// import profilePost from './profilePost'
// import observationPostPing from './observationPostPing'
export default {
    data:() => ({
      likesCounter: 0,
      postLike: false,
      sheet: false,
      top: "",
      fab: "",
      transition: 'slide-y-transition',
      hover: "",
      dialog: false,
    }),
    methods: {
      /*
        //subString creation
        //
        createSubstr(authors, i) {
        if(authors)
            return authors.substr(0, i)
        },
        // Add likes button and counter\
        //
        addlikes(){
          likesCounter++;
          this.postLike = !this.postLike;
        },
        getTime(publishedDate) {
          // Get todays date and the published date and find out how long
          // it's being since the article was posted.
          //
          //const m1 = new Date(); // prints: Toady's date
          const m2 = new Date(publishedDate) // prints: Date of article
          const timeFromNow = moment(m2).fromNow() // Returns time from when article was created
          return timeFromNow
        },
        */
    },
    components: {
      profilePage,
      // profilePost,
      // observationPostPing,
    },
}
</script>